/** Formatting for plans and subscriptions. Amounts come in minor units (paise, cents). */

export const CURRENCIES = ['INR', 'USD']

export const formatMoney = (minor, currency) => {
  if (minor == null) return '—'
  const major = minor / 100
  return new Intl.NumberFormat(currency === 'INR' ? 'en-IN' : 'en-US', {
    style: 'currency',
    currency,
    maximumFractionDigits: Number.isInteger(major) ? 0 : 2,
  }).format(major)
}

export const formatNumber = (value) => (value == null ? 'No limit' : new Intl.NumberFormat('en-IN').format(value))

export const formatStorage = (mb) => {
  if (mb == null) return 'No limit'
  return mb >= 1024 ? `${+(mb / 1024).toFixed(1)} GB` : `${mb} MB`
}

export const formatBytes = (bytes) => {
  if (bytes < 1024 * 1024) return `${Math.max(0, Math.round(bytes / 1024))} KB`
  if (bytes < 1024 ** 3) return `${(bytes / 1024 ** 2).toFixed(1)} MB`
  return `${(bytes / 1024 ** 3).toFixed(1)} GB`
}

/** Whole days from now until the time (0 when it's within a day). */
export const daysUntil = (iso) => (iso ? Math.max(0, Math.ceil((new Date(iso) - Date.now()) / 86_400_000)) : null)

export const plural = (n, word) => `${n} ${word}${n === 1 ? '' : 's'}`

export const PHASES = {
  TRIAL: { label: 'Trial', color: 'info' },
  ACTIVE: { label: 'Active', color: 'success' },
  GRACE: { label: 'Payment overdue', color: 'warning' },
  READ_ONLY: { label: 'Read-only', color: 'error' },
  LOCKED: { label: 'Locked', color: 'error' },
}

export const FEATURE_LABELS = {
  web_forms: 'Web forms',
  integrations: 'API keys & webhooks',
}

/** "18%" from basis points (1800). */
export const formatRate = (bp) => `${+(bp / 100).toFixed(2)}%`

/** How GST shows on a price: CGST + SGST within the seller's state, IGST otherwise; nothing for exports. */
export const taxLabel = (supply, bp) => {
  if (supply === 'INTRA') return `CGST ${formatRate(bp / 2)} + SGST ${formatRate(bp / 2)}`
  if (supply === 'INTER') return `IGST ${formatRate(bp)}`
  return null
}

/** ISO country codes with English names, India first. */
export const COUNTRIES = (() => {
  const names = new Intl.DisplayNames(['en'], { type: 'region' })
  const list = []
  for (let a = 65; a <= 90; a += 1) {
    for (let b = 65; b <= 90; b += 1) {
      const code = String.fromCharCode(a, b)
      // unknown codes come back unchanged; skip groupings and pseudo-regions
      let name
      try { name = names.of(code) } catch { name = code }
      if (name !== code && !['EU', 'EZ', 'UN', 'QO', 'XA', 'XB', 'ZZ'].includes(code) && !/^X/.test(code)) list.push({ code, name })
    }
  }
  list.sort((x, y) => (x.code === 'IN' ? -1 : y.code === 'IN' ? 1 : x.name.localeCompare(y.name)))
  return list
})()

export const countryName = (code) => COUNTRIES.find((c) => c.code === code)?.name || code

/** VEN/2026-27/0001 → VEN-2026-27-0001.pdf */
export const invoiceFileName = (number) => `${number.replace(/\//g, '-')}.pdf`
